export function formatPriceWithSpaces(price: number): string {
  const priceStr = price?.toString();
  const formattedString = priceStr?.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  return formattedString;
}
